import * as React from 'react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import * as POIModule from 'Modules/POIModule';
import * as AOIModule from 'Modules/AOIModule';
import * as AlertModule from 'Modules/AlertModule';
import { injectThProps } from 'HelperFunctions/Lists';
import { createSerachQuery } from 'Connectors/_main';
import { withTranslation  } from 'react-i18next';
import { createZonesArray } from './ZonesHelpers';
type P = {
    tableOnly?: boolean;
    match: any;
};
type ConnectedP = {
    poiStore: POIModule.Types.POIStore;
    aoiStore: AOIModule.Types.AOIStore;
    t?: (key: string) => string;
};
type DispatchedP = {
    getPoiList: (showSideLoader?: boolean) => Function;
    getAoiList: (showSideLoader?: boolean) => Function;
    manageAlertZones: (type: 'ADD' | 'DELETE', zone: AlertModule.Types.DomainOfInterestDto) => Function;
};
type S = {
    activeSorting: string;
    activeFilter: string;
    page: number;
    selected: number;
    expanded: Object;
};
class ZonesList extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
        this.state = {
            activeSorting: '',
            activeFilter: '',
            page: 0,
            selected: null,
            expanded: {}
        };
        this.getFilteredData = this.getFilteredData.bind(this);
    }
    public async componentDidMount() {
        const {tableOnly} = this.props;

        if(!this.props.poiStore.poiList.length) {
            await this.props.getPoiList(!tableOnly);
        }

        if(!this.props.aoiStore.aoiList.length) {
            await this.props.getAoiList(!tableOnly);
        }
    }
    private async getFilteredData(filters: Array<{ id: any; value: any }>) {
        await this.props.getPoiList();
        await this.props.getAoiList();
    }

    private onZoneClick(zone: AlertModule.Types.DomainOfInterestDto) {
        const { match, manageAlertZones } = this.props;
        if (match.path === '/alerts/add' || match.params.alertId) {
            manageAlertZones('ADD', zone);
        }
    }
    public render() {
        const { poiStore, aoiStore, t } = this.props;
        let dataArr = [];
        if (aoiStore.aoiList.length > 0) {
            dataArr = createZonesArray(poiStore.poiList, aoiStore.aoiList);
        }
        const pages = dataArr ? Math.ceil(dataArr.length / 25) : 1;
        return (
            <ReactTable
                className="reactTable vehicleList--table vehicleList--nomaxheight"
                data={dataArr ? dataArr : []}
                loadingText={'Ładowanie...'}
                filterable
                expanded={this.state.expanded}
                pageText={'Strona'}
                pages={pages}
                nextText={'Następna'}
                page={this.state.page}
                showPageSizeOptions={false}
                previousText={'Poprzednia'}
                getTheadThProps={injectThProps}
                rowsText={'wierszy'}
                noDataText={'Brak danych do wyświetlenia'}
                defaultPageSize={dataArr ? dataArr.length : 0}
                pageSize={dataArr ? dataArr.length : 0}
                getTrProps={(state: any, rowInfo: any) => {
                    return {
                        onClick: () => {
                            this.setState({ selected: rowInfo.index });
                            this.onZoneClick(rowInfo.original);
                            // this.props.setActiveFleet(rowInfo.original);
                        }
                        // className: rowInfo.index === this.state.selected ? 'active' : ''
                    };
                }}
                manual
                // SubComponent={row => <FleetCarBlock fleetDto={row.original} />}
                onPageChange={page => this.setState({ page })}
                // onFetchData={(state, instance) => {
                //     const query = checkPageQuery(state.filtered, state.page);
                //     this.getFilteredData(query);
                // }}
                columns={[
                    {
                        Header: 'hiddenHeader',
                        id: 'type',
                        accessor: 'type',
                        Filter: () => <p className="bold">{t('zoneType')}</p>,
                        Cell: ({ value }) => <span>{value}</span>,
                        width: 250
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'title',
                        accessor: 'title',
                        Filter: () => <p className="bold">{t('title')}</p>,
                        Cell: ({ value }) => <p>{value}</p>
                    },
                    {
                        Header: 'hiddenHeader',
                        id: 'address',
                        accessor: 'address',
                        Filter: () => <p className="bold">{t('address')}</p>,
                        Cell: ({ value }) => <p>{value}</p>
                    }
                ]}
            />
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        poiStore: state.poiStore,
        aoiStore: state.aoiStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getPoiList: (showSideLoader?: boolean) => dispatch(POIModule.Actions.getPoiList(-1, showSideLoader)),
        getAoiList: (showSideLoader?: boolean) => dispatch(AOIModule.Actions.getAoiList(-1, showSideLoader)),
        manageAlertZones: (type: 'ADD' | 'DELETE', zone: AlertModule.Types.DomainOfInterestDto) => dispatch(AlertModule.Actions.manageDomainOfIntrest(type, zone))
    };
}

export default withTranslation ('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(ZonesList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Zones/ZonesList.tsx